<template>
  <div class="search-box">
    <el-form ref="searchFormRef" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="职业" prop="userType">
        <el-select filterable v-model="formInline.userType" placeholder="">
          <el-option v-for="item in allType" :key="item.id" :label="item.roleName" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="formInline.name" placeholder="请输入姓名" />
      </el-form-item>
      <el-form-item label="账号" prop="userName">
        <el-input v-model="formInline.userName" placeholder="请输入账号" />
      </el-form-item>
      <el-form-item label="性别" prop="sex">
        <el-select v-model="formInline.sex" placeholder="请选择性别">
          <el-option label="男" :value="1" />
          <el-option label="女" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="onReset(searchFormRef)">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-box">
    <div class="table-btns">
      <el-button type="primary" @click="addFn">新增</el-button>
      <el-button type="danger" :disabled="selectionTable.length == 0" @click="batchDelFn">批量删除</el-button>
      <el-button type="primary" @click="downloadFn">下载模板</el-button>
      <el-button type="primary" @click="uploadFn">导入</el-button>
      <el-button type="primary" @click="exportFn">导出</el-button>
      <!-- <el-upload
        ref="upload"
        style="display: inline-block; margin-left: 10px"
        accept=".xls,.xlsx"
        :file-list="fileList"
        :show-file-list="false"
        :headers="headers"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :before-upload="beforeUploadFile"
        :action="userImport()"
        v-loading="uploading"
        ><el-button type="primary">导入</el-button>
      </el-upload> -->
    </div>
    <el-table :data="tableData" @selection-change="handleSelectionChange" style="width: 100%">
      <el-table-column type="selection" align="center" width="55" />
      <el-table-column type="index" label="序号" align="center" width="90" />
      <el-table-column prop="name" label="姓名" align="center" />
      <!-- <el-table-column prop="userTypeText" label="职业" align="center" /> -->
      <el-table-column prop="sex" label="性别" align="center">
        <template #default="scope">
          <span>{{ scope.row.sex == 1 ? "男" : "女" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="账号" align="center" />
      <el-table-column prop="userTotal" label="刷题进度" align="center">
        <template #default="scope">
          <span :class="scope.row.userTotal >= scope.row.total && scope.row.total != 0
            ? 'success'
            : ''
            ">{{ scope.row.userTotal }} / {{ scope.row.total }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="开卡时间" align="center" />
      <el-table-column prop="expireTime" label="到期时间" align="center">
        <template #default="scope">
          <span :class="new Date() > new Date(scope.row.expireTime + ' 23:59:59') ? 'red' : 'success'">{{
            scope.row.expireTime
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop=" address" label="操作" align="center">
        <template #default="scope">
          <el-button type="primary" size="small" @click="editFn(scope.row)">修改</el-button>
          <el-button type="danger" size="small" @click="delFn(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" v-model:current-page="currentPage" v-model:page-size="pageSize"
      :page-sizes="[10, 50, 100, 200]" :small="small" :disabled="disabled" :background="background"
      layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />
  </div>
  <el-dialog v-model="modelDialogVisible" append-to-body :close-on-click-modal="false" :width="600" title="学员导入">
    <modelDialog v-if="modelDialogVisible" ref="modelDialogRef" @dialogClose="dialogClose" />
  </el-dialog>
  <el-dialog v-model="dialogVisible" append-to-body :close-on-click-modal="false" :width="600" :title="dialogTitle">
    <userAddEditDialog v-if="dialogVisible" ref="addEditDialogRef" @dialogClose="dialogClose" />
  </el-dialog>
</template>

<script setup>
import { reactive, ref, onMounted, nextTick } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import userAddEditDialog from "./dialog/userAddEditDialog.vue";
import modelDialog from "./dialog/modelDialog.vue";
import { userList, userDelete, roleAll, userExport,userExportList } from "@/http/http";
let dialogVisible = ref(false);
let modelDialogVisible = ref(false);
let modelDialogRef = ref(null);
let dialogTitle = ref("");
let addEditDialogRef = ref(null);
let allType = ref("");
const tableData = ref([]);
let selectionTable = ref([]);
const addFn = () => {
  dialogVisible.value = true;
  dialogTitle.value = "新增";
};
const editFn = (row) => {
  dialogVisible.value = true;
  dialogTitle.value = "修改";
  nextTick(() => {
    addEditDialogRef.value.init(row);
  });
};

const downloadFn = () => {
  userExport().then((res) => {
    if (res.data) {
      let data = new Blob([res.data], {
        type: "application/vnd.ms-excel,charset=utf-8",
      });
      if (typeof window.chrome !== "undefined") {
        // Chrome
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(data);
        link.download = "学员导入模板.xlsx";
        link.click();
      } else if (typeof window.navigator.msSaveBlob !== "undefined") {
        // IE
        var blob = new Blob([data], { type: "application/force-download" });
        window.navigator.msSaveBlob(blob, "学员导入模板.xlsx");
      } else {
        // Firefox
        var file = new File([data], "学员导入模板.xlsx", {
          type: "application/force-download",
        });
        window.open(URL.createObjectURL(file));
      }
    }
  });
};
const uploadFn = () => {
  modelDialogVisible.value = true;
};
const exportFn = () => {
  userExportList({
    size: pageSize.value,
    current: currentPage.value,
    ...formInline,
  }).then((res) => {
    if (res.data) {
      let data = new Blob([res.data], {
        type: "application/vnd.ms-excel,charset=utf-8",
      });
      if (typeof window.chrome !== "undefined") {
        // Chrome
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(data);
        link.download = "学员列表.xlsx";
        link.click();
      } else if (typeof window.navigator.msSaveBlob !== "undefined") {
        // IE
        var blob = new Blob([data], { type: "application/force-download" });
        window.navigator.msSaveBlob(blob, "学员列表.xlsx");
      } else {
        // Firefox
        var file = new File([data], "学员列表.xlsx", {
          type: "application/force-download",
        });
        window.open(URL.createObjectURL(file));
      }
    }
  });
};

const batchDelFn = () => {
  ElMessageBox.confirm("请确认是否删除？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
    closeOnClickModal: false,
  }).then(() => {
    console.log(selectionTable.value);
    let ids = [];
    selectionTable.value.forEach((item) => {
      ids.push(item.id);
    });
    _userDelete(ids.join());
  }).catch(() => {

  })
};
const delFn = (row) => {
  ElMessageBox.confirm("请确认是否删除？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
    closeOnClickModal: false,
  }).then(() => {
    _userDelete(row.id);
  }).catch(() => {

  })
};
const _roleAll = () => {
  roleAll().then((res) => {
    if (res.data.code == 200) {
      console.log(res.data);
      allType.value = res.data.data
      if (res.data.data && res.data.data.length > 0) {
        formInline.userType = res.data.data[0].id
      }
      _userList();
    }
  });
};


const _userDelete = (ids) => {
  userDelete(ids).then((res) => {
    if (res.data.code == 200) {
      ElMessage({
        message: res.data.message,
        type: "success",
      });
      _userList();
    }
  });
};
const dialogClose = (flag) => {
  console.log(flag);
  dialogVisible.value = false;
  modelDialogVisible.value = false;
  if (flag) {
    onSubmit();
  }
};

const formInline = reactive({
  userType: 1,
  name: "",
  userName: "",
  sex: "",
  type: "",
});
const searchFormRef = ref();
const onSubmit = () => {
  _userList();
};
const onReset = (formEl) => {
  formEl.resetFields();
  pageSize.value = 10;
  currentPage.value = 1;
  _userList();
};
const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);
const handleSizeChange = (val) => {
  pageSize.value = val;
  _userList();
};
const handleCurrentChange = (val) => {
  currentPage.value = val;
  _userList();
};
const handleSelectionChange = (val) => {
  selectionTable.value = val;
};
const _userList = () => {
  userList({
    size: pageSize.value,
    current: currentPage.value,
    ...formInline,
  }).then((res) => {
    tableData.value = res.data.data.records;
    total.value = res.data.data.total;
  });
};
let fileList = ref([]);
let headers = ref({
  token: $cookies.get("token"),
});
let uploading = ref(false);
const beforeUploadFile = (file) => {
  uploading.value = true;
  const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
  if (extension != "xls" && extension != "xlsx") {
    ElMessage({
      message: "只能导入excel文件",
      type: "error",
    });
    uploading.value = false;
  }
  return extension == "xls" || extension == "xlsx";
};
const uploadSuccess = (response, file, fileList) => {
  uploading.value = false;
  if (response.code == 200) {
    ElMessage({
      message: "导入成功",
      type: "success",
    });
    _userList();
  }
};
const upload = ref();
const uploadError = () => {
  uploading.value = false;
  upload.value.clearFiles();
  ElMessage({
    message: "导入失败,请尝试重新导入或联系管理员",
    type: "error",
  });
};
onMounted(() => {
  _roleAll();
});
</script>
<style scoped lang="scss">
.success {
  color: #02bc6c;
}

.red {
  color: #da0f0f;
}
</style>
